export const getSwarmSetRfidPinCodeRequest = params => ({
    name: "SetRFIDPin",
    params,
});

export const getSwarmRfidPinLoginNeededRequest = params => ({
    name: "CheckIfRFIDPinNeededOnLogin",
    params,
});